<template>
  <section class="h_54">
    <div class="bg-wrapper">
      <m-img src="@/v2/mobile/assets/image/h_54.jpg" class="bg-image"></m-img>
      <div class="avatar-grid-section">
        <div class="avatar-grid" v-ia>
          <div class="avatar-column left">
            <div
              class="avatar-card-wrap"
              v-for="(avatar, index) in leftAvatars"
              :key="index"
            >
              <div class="avatar-content" @click="playVoiceLeft(index)">
                <RoleBorder
                  class="role_border"
                  :style="{ color: avatar.themeColor }"
                />
                <m-video
                  :ref="`playVideo_left_${index}`"
                  class="role_animation"
                  muted
                  disablepictureinpicture
                  x5-playsinline
                  playsinline
                  webkit-playsinline="true"
                  autoplay
                  preload="auto"
                  :style="{ opacity: playIndex === index * 2 ? 1 : 0 }"
                  src="@/v2/auto/assets/video/54/role_animation.mp4"
                />
                <m-img :src="avatar.image" class="avatar-image"></m-img>
                <RoleFill
                  :ref="`roleFill_left_${index}`"
                  class="role_fill"
                  :style="{ color: avatar.themeColor }"
                />
                <div class="avatar-info">
                  <div class="avatar-info-content">
                    <div class="avatar-name">{{ avatar.name }}</div>
                    <div class="avatar-role">{{ avatar.role }}</div>
                  </div>
                  <div class="role_play_layer">
                    <div class="role_play_layer_1" />
                    <div
                      :ref="`rolePlayLayer2_left_${index}`"
                      class="role_play_layer_2"
                    />
                    <div
                      :ref="`playRef_left_${index}`"
                      class="play-animation"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="avatar-column right">
            <div
              class="avatar-card"
              v-for="(avatar, index) in rightAvatars"
              :key="index"
            >
              <div class="avatar-content" @click="playVoiceRight(index)">
                <m-video
                  :ref="`playVideo_right_${index}`"
                  class="role_animation"
                  muted
                  disablepictureinpicture
                  x5-playsinline
                  playsinline
                  webkit-playsinline="true"
                  preload="auto"
                  :style="{ opacity: playIndex === index * 2 + 1 ? 1 : 0 }"
                  src="@/v2/auto/assets/video/54/role_animation.mp4"
                />
                <RoleBorder
                  class="role_border"
                  :style="{ color: avatar.themeColor }"
                />
                <m-img :src="avatar.image" class="avatar-image"></m-img>
                <RoleFill
                  :ref="`roleFill_right_${index}`"
                  class="role_fill"
                  :style="{ color: avatar.themeColor }"
                />
                <div class="avatar-info">
                  <div>
                    <div class="avatar-name">{{ avatar.name }}</div>
                    <div class="avatar-role">{{ avatar.role }}</div>
                  </div>
                  <div class="role_play_layer">
                    <div class="role_play_layer_1" />
                    <div
                      :ref="`rolePlayLayer2_right_${index}`"
                      class="role_play_layer_2"
                    />
                    <div
                      :ref="`playRef_right_${index}`"
                      class="play-animation"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Role1 from '@/v2/mobile/assets/image/h_54_role/role1.png'
import Role2 from '@/v2/mobile/assets/image/h_54_role/role2.png'
import Role3 from '@/v2/mobile/assets/image/h_54_role/role3.png'
import Role4 from '@/v2/mobile/assets/image/h_54_role/role4.png'
import Role5 from '@/v2/mobile/assets/image/h_54_role/role5.png'
import Role6 from '@/v2/mobile/assets/image/h_54_role/role6.png'
import playJson from '@/v2/mobile/assets/image/h_54_role/voice.json'
import lottie from 'lottie-web'
import { CustomEase } from 'gsap/CustomEase'

import audio1 from '@/v2/mobile/assets/audio/1.aac'
import audio2 from '@/v2/mobile/assets/audio/2.aac'
import audio3 from '@/v2/mobile/assets/audio/3.aac'
import audio4 from '@/v2/mobile/assets/audio/4.aac'
import audio5 from '@/v2/mobile/assets/audio/5.aac'
import audio6 from '@/v2/mobile/assets/audio/6.aac'
import RoleBorder from '@/v2/mobile/assets/image/h_54_role/role_border.vue'
import RoleFill from '@/v2/mobile/assets/image/h_54_role/role_fill.vue'
export default {
  components: {
    RoleBorder,
    RoleFill,
  },
  data() {
    const allAvatars = [
      {
        name: '妩媚御姐',
        role: '低回婉转 磁性质感',
        image: Role1,
        audio: new Audio(audio1),
        playAnimation: null,
        themeColor: '#C54246',
      },
      {
        name: '乐呵老头',
        role: '腔调逗趣 爽朗诙谐',
        image: Role2,
        audio: new Audio(audio2),
        playAnimation: null,
        themeColor: '#3C8D38',
      },
      {
        name: '河南憨哥',
        role: '俚语连珠 倔强憨厚',
        image: Role3,
        audio: new Audio(audio3),
        playAnimation: null,
        themeColor: '#E5B739',
      },
      {
        name: '胡同侃爷',
        role: '京腔卷舌 侃侃而谈',
        image: Role4,
        audio: new Audio(audio4),
        playAnimation: null,
        themeColor: '#A94A2F',
      },
      {
        name: '青岛小哥',
        role: '痞气上扬 开朗热情',
        image: Role5,
        audio: new Audio(audio5),
        playAnimation: null,
        themeColor: '#25B098',
      },
      {
        name: '广西老表',
        role: '朴实热情 夹壮鼻音',
        image: Role6,
        audio: new Audio(audio6),
        playAnimation: null,
        themeColor: '#2586B0',
      },
    ]

    return {
      preload_: true,
      playIndex: null,
      isPlaying: false,
      leftAvatars: allAvatars.filter((_, index) => index % 2 === 0),
      rightAvatars: allAvatars.filter((_, index) => index % 2 === 1),
    }
  },
  mounted() {
    this.initRole()
  },
  methods: {
    initRole() {
      this.leftAvatars.forEach((avatar, index) => {
        const el = this.$refs[`playRef_left_${index}`][0]
        avatar.playAnimation = lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: true,
          autoplay: false,
          animationData: playJson,
        })
      })
      this.rightAvatars.forEach((avatar, index) => {
        const el = this.$refs[`playRef_right_${index}`][0]
        avatar.playAnimation = lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: true,
          autoplay: false,
          animationData: playJson,
        })
      })
    },
    stopAllAudio() {
      // 停止所有 audio
      ;[...this.leftAvatars, ...this.rightAvatars].forEach((item) => {
        if (item.audio) {
          item.audio.pause()
          item.audio.currentTime = 0
        }
      })
    },
    resetAllRoleFill() {
      // 左侧
      this.leftAvatars.forEach((_, i) => {
        const el = this.$refs[`roleFill_left_${i}`]?.[0]?.$el
        if (el) el.style.opacity = 1
      })
      // 右侧
      this.rightAvatars.forEach((_, i) => {
        const el = this.$refs[`roleFill_right_${i}`]?.[0]?.$el
        if (el) el.style.opacity = 1
      })
      // 重置右侧所有动画
      this.rightAvatars.forEach((item, i) => {
        this.animationHandler(item, false, i * 2 + 1, 'right')
      })
      // 重置左侧所有动画
      this.leftAvatars.forEach((item, i) => {
        this.animationHandler(item, false, i * 2, 'left')
      })
    },
    playVoiceLeft(index) {
      const avatar = this.leftAvatars[index]
      const globalIndex = index * 2

      // 如果点击的是当前正在播放的角色，则停止播放
      if (this.playIndex === globalIndex) {
        this.stopAllAudio()
        this.resetAllRoleFill()
        this.animationHandler(avatar, false, globalIndex, 'left')
        this.playIndex = null
        return
      }

      // 开始新的播放
      this.stopAllAudio()
      this.resetAllRoleFill()
      this.playIndex = globalIndex
      this.leftAvatars.forEach((item, i) => {
        this.animationHandler(item, false, i * 2, 'left')
      })
      this.animationHandler(avatar, true, globalIndex, 'left')
    },
    playVoiceRight(index) {
      const avatar = this.rightAvatars[index]
      const globalIndex = index * 2 + 1

      // 如果点击的是当前正在播放的角色，则停止播放
      if (this.playIndex === globalIndex) {
        this.stopAllAudio()
        this.resetAllRoleFill()
        this.animationHandler(avatar, false, globalIndex, 'right')
        this.playIndex = null
        return
      }

      // 开始新的播放
      this.stopAllAudio()
      this.resetAllRoleFill()
      this.playIndex = globalIndex
      this.rightAvatars.forEach((item, i) => {
        this.animationHandler(item, false, i * 2 + 1, 'right')
      })
      this.animationHandler(avatar, true, globalIndex, 'right')
    },
    animationHandler(avatar, isPlay, globalIndex, side) {
      const { playAnimation, audio } = avatar
      const gsap = this.$gsap
      let playVideo = null
      let roleFill = null
      let rolePlayLayer2 = null
      // 区分左右，获取对应的 m-video ref
      if (side === 'left') {
        const leftIndex = Math.floor(globalIndex / 2)
        playVideo = this.$refs[`playVideo_left_${leftIndex}`]?.[0]
        roleFill = this.$refs[`roleFill_left_${leftIndex}`]?.[0].$el
        rolePlayLayer2 = this.$refs[`rolePlayLayer2_left_${leftIndex}`]?.[0]
      } else {
        const rightIndex = Math.floor(globalIndex / 2)
        playVideo = this.$refs[`playVideo_right_${rightIndex}`]?.[0]
        roleFill = this.$refs[`roleFill_right_${rightIndex}`]?.[0].$el
        rolePlayLayer2 = this.$refs[`rolePlayLayer2_right_${rightIndex}`]?.[0]
      }
      const ease = CustomEase.create('custom', '0.33, 0, 0.67, 1')
      const fadeOut = { opacity: 1, duration: 0.5, ease }
      const fadeIn = { opacity: 0, duration: 0.5, ease }

      const audioStopHandler = () => {
        audio.removeEventListener('ended', audioStopHandler)
        // 播放完成后自动隐藏，重置状态
        this.animationHandler(avatar, false, globalIndex, side)
        this.playIndex = null // 重置播放索引
      }

      if (isPlay) {
        gsap.to(playVideo, fadeOut)
        playAnimation.play()
        gsap.to(roleFill, fadeIn)
        gsap.to(rolePlayLayer2, fadeOut)
        audio.currentTime = 0
        audio.play()
        if (playVideo) {
          playVideo.currentTime = 0
          playVideo.play()
        }
        audio.addEventListener('ended', audioStopHandler)
      } else {
        gsap.to(playVideo, { ...fadeIn, duration: 0.3 })
        if (playVideo) playVideo.pause()
        playAnimation.stop()
        gsap.to([roleFill], { ...fadeOut, duration: 0.3 })
        gsap.to(rolePlayLayer2, { ...fadeIn, duration: 0.3 })
        audio.pause()
        audio.removeEventListener('ended', audioStopHandler)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.h_54 {
  position: relative;
  width: 100%;

  .bg-wrapper {
    position: relative;
    width: 100%;
  }

  .bg-image {
    width: 100%;
    display: block;
  }

  .avatar-grid-section {
    position: absolute;
    top: 33%;
    left: 0;
    width: 100%;
  }

  .avatar-grid {
    display: flex;
    gap: 8px;
    max-width: 100%;
    margin: 0 20px;
    padding: 0;
  }

  .avatar-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;

    &.right {
      margin-top: 60px;
    }
  }

  .avatar-card-wrap,
  .avatar-card {
    // 让左右两侧卡片样式一致
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    .avatar-content {
      position: relative;
      display: flex;
      justify-content: center;
      .role_border {
        position: absolute;
        z-index: 0;
        bottom: 0;
        width: 40vw;
        height: 40vw;
      }
      .role_fill {
        position: absolute;
        z-index: 3;
        bottom: 0;
        height: 40vw;
        width: 100%;
      }
      .role_animation {
        position: absolute;
        z-index: 1;
        left: 50%;
        bottom: 0;
        width: 40vw;
        height: 40vw;
        transform: translateX(-50%);
        transition: opacity 0.3s;
        pointer-events: none;
        object-fit: cover;
        border-radius: 12px;
        background: #000;
        opacity: 0;
      }
    }
  }

  .avatar-image {
    position: relative;
    display: block;
    margin: 0 auto;
    object-fit: cover;
    object-position: center;
    z-index: 2;
    background: transparent;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .avatar-info {
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 6%;
    z-index: 4;
    color: #fff;
    text-align: left;
    padding: 0 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .avatar-name {
    font-size: clamp(15px, 3vw, 20px);
    font-weight: 700;
    margin-bottom: 4px;
    color: #fff;
    line-height: 1.1;
  }

  .avatar-role {
    font-size: clamp(10px, 2vw, 14px);
    opacity: 0.85;
    color: #fff;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    line-height: 1.2;
  }

  .play-animation {
    width: clamp(30px, 8vw, 56px);
    height: clamp(30px, 8vw, 56px);
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .role_play_layer {
    position: relative;
    width: clamp(30px, 8vw, 56px);
    height: clamp(30px, 8vw, 56px);
    border-radius: 100px;
    overflow: hidden;
    z-index: 5;

    .role_play_layer_1 {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
      background: rgba(255, 255, 255, 0.18);
    }

    .role_play_layer_2 {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      background: linear-gradient(
        134.57deg,
        #7b5efe 11.84%,
        #ec63bf 76.91%,
        #fa7260 95.59%
      );
    }
  }
}
</style>
